// @core/api/endpoints/authn/request_password_reset.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  RequestPasswordResetRequest,
} from '../../../types/authn';

const BASE_PATH = '/authn';

/**
 * Request password reset link
 * Initiates the password reset flow by sending a reset link to the user's email. For security, always returns success regardless of whether the email exists in the system.
 * @public This endpoint does not require authentication
 */
export async function RequestPasswordReset(
  data: RequestPasswordResetRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/auth/password/reset/request`;
  const requestOptions = { ...options, skipAuth: true };
  return client.post<Response>(requestPath, data, requestOptions);
}
